import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "../utils/interceptors/sag-auth-interceptor";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";
import { addLoggerInterceptor } from "../utils/interceptors/logger-interceptor";
import { addPlayerIdInterceptor } from "../utils/interceptors/player-id-interceptor";

const { getSagApiUrl } = useSagOptions();

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: getSagApiUrl("ben-be-player", "player"),
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const benPlayerClient = axios.create(config);

addSagAuthInterceptor(benPlayerClient);
addLoggerInterceptor(benPlayerClient);
addPlayerIdInterceptor(benPlayerClient);

export { benPlayerClient };
